import { defineStore, acceptHMRUpdate } from 'pinia'

export const useUserStore = defineStore(
  'user',
  () => {
    const initState = { userName: '', avatar: '' }
    const userInfo = ref<IUserInfo>({ ...initState })
    const systemInfo = ref<any>({})
    const shopInfo = ref<any>({})
    const token = ref('')
    const deviceInfo = ref<any>({})
    const showHasDishes = ref(false)
    const setDeviceInfo = (val: any) => {
      deviceInfo.value = val
    }
    const clearDevice = () => {
      deviceInfo.value = {}
    }
    const setUserInfo = (val: IUserInfo) => {
      userInfo.value = val
    }
    const setToken = (val: string) => {
      token.value = val
    }
    const clearUserInfo = () => {
      userInfo.value = { ...initState }
      token.value = ''
    }

    const setSystemInfo = (val: any) => {
      systemInfo.value = val
    }
    const clearSystemInfo = () => {
      systemInfo.value = {}
    }
    const setShopInfo = (val: any) => {
      shopInfo.value = val
    }
    const clearShopInfo = () => {
      shopInfo.value = {}
    }
    // 一般没有reset需求，不需要的可以删除
    const reset = () => {
      userInfo.value = { ...initState }
      systemInfo.value = {}
      shopInfo.value = {}
      token.value = ''
      deviceInfo.value = {}
    }
    const isLogined = computed(() => !!token.value)
    return {
      token,
      setToken,
      userInfo,
      setUserInfo,
      clearUserInfo,
      isLogined,
      systemInfo,
      setSystemInfo,
      clearSystemInfo,
      shopInfo,
      setShopInfo,
      clearShopInfo,
      reset,
      deviceInfo,
      setDeviceInfo,
      clearDevice,
      showHasDishes
    }
  },
  {
    persist: true,
  },
)
// 确保传递正确的 store 声明
if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useUserStore, import.meta.hot))
}
